function getTextCase(textCase) {
  if (textCase === "UPPER") {
    return "uppercase";
  }

  if (textCase === "CAPITAL") {
    return "capitalize";
  }

  return "normal";
}
/**
 * Returns styles for Label nodes.
 */


export function getStyledTextAttributes(_a) {
  var _b = _a === void 0 ? {} : _a,
      fillColor = _b.fillColor,
      fontFamily = _b.fontFamily,
      fontWeight = _b.fontWeight,
      textDecoration = _b.textDecoration,
      letterSpacing = _b.letterSpacing,
      lineHeight = _b.lineHeight,
      size = _b.size,
      textCase = _b.textCase;

  return "\n    ".concat(fillColor ? "color: ".concat(fillColor, ";") : "", "\n    ").concat(fontFamily ? "font-family: ".concat(fontFamily, ";") : "", "\n    ").concat(size ? "font-size: ".concat(size / 16, "rem;") : "", "\n    ").concat(lineHeight ? "line-height: ".concat(lineHeight, "px;") : "", "\n    ").concat(textDecoration ? "text-decoration: ".concat(textDecoration, ";") : "", "\n    ").concat(letterSpacing ? "letter-spacing: ".concat(letterSpacing, "px;") : "", "\n    ").concat(textCase ? "text-transform: ".concat(getTextCase(textCase), ";") : "", "\n    ").concat(fontWeight ? "font-weight: ".concat(fontWeight, ";") : "", "\n    margin: 0;\n  ");
}
/**
 * Returns styles for nodes that support theming,
 * like Buttons and Views.
 */

export function getStyledNodeAttributes(_a, isSeparator) {
  var _b = _a === void 0 ? {} : _a,
      boxShadow = _b.boxShadow,
      cornerRadius = _b.cornerRadius,
      fillColor = _b.fillColor,
      stroke = _b.stroke;

  if (isSeparator === void 0) {
    isSeparator = false;
  }

  return "\n    ".concat(boxShadow ? "box-shadow: ".concat(boxShadow.offset.x, "px ").concat(boxShadow.offset.y, "px ").concat(boxShadow.radius, "px ").concat(boxShadow.spread || 0, "px ").concat(boxShadow.color) : "", ";\n    ").concat(cornerRadius ? "border-radius: ".concat(cornerRadius, "px;") : "", "\n    ").concat(fillColor ? "background: ".concat(fillColor, ";") : "", "\n    ").concat(stroke ? "border".concat(isSeparator ? "-bottom" : "", ": ").concat(stroke.weight, "px ").concat(stroke.type, " ").concat(stroke.color) : "", ";\n  ");
}
/**
 * Returns styles for nodes that support frame attributes,
 * like Views or Linear Layouts.
 */

export function getFrameAttributes(_a) {
  var _b = _a === void 0 ? {} : _a,
      width = _b.width,
      height = _b.height,
      padding = _b.padding;

  return "\n  // Dimensions\n  ".concat((width === null || width === void 0 ? void 0 : width.resize) === "fixed" ? "width: 100%;" : "", "\n  ").concat((width === null || width === void 0 ? void 0 : width.resize) === "fixed" ? "height: 100%;" : "", "\n  ").concat((width === null || width === void 0 ? void 0 : width.resize) === "fixed" && width.min ? "min-width: ".concat(width.min, "px") : "", ";\n  ").concat((height === null || height === void 0 ? void 0 : height.resize) === "fixed" && height.min ? "min-height: ".concat(height.min, "px") : "", ";\n  ").concat((width === null || width === void 0 ? void 0 : width.resize) === "fixed" && width.max ? "max-width: ".concat(width.max, "px") : "", ";\n  ").concat((height === null || height === void 0 ? void 0 : height.resize) === "fixed" && height.max ? "max-height: ".concat(height.max, "px") : "", ";\n\n  // Frame\n  padding-top: ").concat((padding === null || padding === void 0 ? void 0 : padding.top) || 0, "px;\n  padding-right: ").concat((padding === null || padding === void 0 ? void 0 : padding.right) || 0, "px;\n  padding-bottom: ").concat((padding === null || padding === void 0 ? void 0 : padding.bottom) || 0, "px;\n  padding-left: ").concat((padding === null || padding === void 0 ? void 0 : padding.left) || 0, "px;\n\n  [data-direction=\"horizontal\"] > && {\n    ").concat((width === null || width === void 0 ? void 0 : width.resize) === "fill" ? "flex: 1;" : "", "\n    ").concat((height === null || height === void 0 ? void 0 : height.resize) === "fill" ? "align-self: stretch;" : "", "\n    ").concat((width === null || width === void 0 ? void 0 : width.resize) !== "fill" ? "min-width: ".concat((width === null || width === void 0 ? void 0 : width.min) || (width === null || width === void 0 ? void 0 : width.max) || 0, "px;") : "", "\n  }\n\n  [data-direction=\"vertical\"] > && {\n    ").concat((height === null || height === void 0 ? void 0 : height.resize) === "fill" ? "flex: 1;" : "", "\n    ").concat((width === null || width === void 0 ? void 0 : width.resize) === "fill" ? "width: 100%;" : "", "\n  }\n");
}
/**
 * Returns the secondary axis of a node.
 */

export function getSecondaryAxis(direction) {
  return direction === "horizontal" ? "vertical" : "horizontal";
}
/** Returns alignment of an axis. */

export function getAlignment(alignment, direction) {
  // Fixme: Type error, doesnt exist...
  // : React.CSSProperties["alignItems"] {
  var align = alignment === null || alignment === void 0 ? void 0 : alignment[direction];
  if (align === "center") return "center";
  if (align === "fill") return "stretch";
  if (align === "end") return "flex-end";
  return "flex-start";
}
/** Returns justification. */

export function getJustification(distribution, direction, alignment) {
  // Fixme: Type error, doesnt exist...
  // : React.CSSProperties["justifyContent"] {
  if (distribution === "equalAround") return "space-around";
  if (distribution === "equalSpacing") return "space-between";
  if (distribution === "fillEqually") return "stretch; > * { flex: 1; }"; // If the distribution is fillProportionately,
  // justification is based on the alignment
  // of the primary axis. E.g. if a horizontal
  // layout has an "end" horizontal alignment,
  // its justification should be flex end.

  return getAlignment(alignment, direction);
}
/** Maps a prop object to an identically structured object where each key is prefixed with $ for use with styled-components transient props. */

export var prefixWith$ = function prefixWith$(obj) {
  return Object.fromEntries(Object.entries(obj || {}).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return [key.startsWith("on") ? key : "$".concat(key), value];
  }));
};